'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = require('react-bootstrap/lib/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Radio2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Radio.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Radio.js
 ** module chunks = 0
 **/